// extracted by mini-css-extract-plugin
export var brief = "MarkdownContent-module--brief--ea3af";
export var content = "MarkdownContent-module--content--2568a";
export var dropcap = "MarkdownContent-module--dropcap--59e45";